import KBaseMap from "@/components/Maps/KBaseMap";
import KHistoryMarker from "../markers/KHistoryMarker";
import KScheduleMarker from "../markers/KScheduleMarker";
import KStoreMarker from "../markers/KStoreMarker";
import KTrucksMapAlertsSidebar from "../sidebars/KTrucksMapAlertsSidebar";
import KTrucksMapDetailsSidebar from "../sidebars/KTrucksMapDetailsSidebar";
import { FetchesData } from "kinnect-mixins";
import { StoreLocation, YardTrip } from "kinnect-models";

export default {
	name: "KTripHistoryMap",

	mixins: [ FetchesData ],

	props: {
		idTrip: {
			required: true,
			type: Number
		},

		storeModuleName: {
			required: true,
			type: String
		}
	},

	data: () => ( {
		historyOptions: {
			clickable: false,
			geodesic: true,
			strokeColor: "#E91E63",
			strokeOpacity: 0.7,
			strokeWeight: 7
		},
		stores: [],
		trip: null
	} ),

	computed: {
		loadingTrip() {
			return this.$wait.is( "get trips" );
		},

		loading() {
			return this.fetching || this.loadingTrip;
		}
	},

	watch: {
		idTrip() {
			this.fetchTripHistory();
		},

		trip( val ) {
			this.$emit( "tripLoaded", val );
		}
	},

	methods: {
		async fetchTripHistory() {
			this.trip = await YardTrip
			.custom( `yard/trips/${this.idTrip}/history` )
			.first();
		},

		async fetchStores() {
			this.stores = await StoreLocation.get();
		},

		async fetch() {
			await this.$http.all( [
				this.fetchTripHistory(),
				this.fetchStores()
			] );
		}
	},

	render() {
		return <KBaseMap
			storeModuleName={this.storeModuleName}
			fitMarkerTypeToBounds="history"
			spiderfy
		>
			<KTrucksMapDetailsSidebar
				loading={this.loading}
				slot="left-sidebar"
				trip={this.trip}
			></KTrucksMapDetailsSidebar>

			<KTrucksMapAlertsSidebar
				alerts={this.trip && this.trip.alerts ? this.trip.alerts : undefined}
				loading={this.loading}
				slot="right-sidebar"
				title={this.trip && this.trip.truck ? `${this.trip.truck.name} Alerts` : "Alerts"}
			></KTrucksMapAlertsSidebar>

			{this.trip && this.trip.history && [
				<gmap-polyline
					options={this.historyOptions}
					path={this.trip.history}
				></gmap-polyline>,

				this.trip.history.map( ( item, index ) =>
					<KHistoryMarker
						isFirst={index === 0}
						isLast={index === this.trip.history.length - 1}
						item={item}
						key={`history-${item.date}`}
						markerId={item.date}
					></KHistoryMarker>
				)
			]}

			{this.trip && this.trip.schedules && this.trip.schedules.map( schedule =>
				<KScheduleMarker
					key={`schedule-${schedule.id}`}
					schedule={schedule}
				></KScheduleMarker>
			)}

			{this.stores.map( store =>
				<KStoreMarker
					key={`store-${store.name}`}
					store={store}
				></KStoreMarker>
			)}
		</KBaseMap>;
	}
};
